export const exampleCases = [
  {
    section: "Intro",
    name: "Maximo",
    age: "",
    origin_country: "Guatemala",
    arrest_date: "01/01/2026",
    description: "Arrested in Brooklyn while out buying milk for his kids.",
    bolded_part: "buying milk for his kids",
  },
  {
    section: "Intro",
    name: "Luis",
    age: "",
    origin_country: "Colombia",
    arrest_date: "1/27/2026",
    description: "Arrested on his way to get coffee. He is legally blind.",
    bolded_part: "legally blind",
  },
  {
    section: "Intro",
    name: "Fernando",
    age: "",
    origin_country: "Mexico",
    arrest_date: "12/20/2025",
    description:
      "Arrested at his daughter's soccer practice in Passaic, New Jersey.",
    bolded_part: "daughter's soccer practice",
  },
  {
    section: "Intro",
    name: "Elmer",
    age: "",
    origin_country: "Mexico",
    arrest_date: "1/29/26",
    description:
      "Arrested in The Bronx on the way to visit his wife in the hospital.",
    bolded_part: "wife in the hospital",
  },
  {
    section: "Intro",
    name: "Jose",
    age: "",
    origin_country: "Ecuador",
    arrest_date: "11/1/2025",
    description:
      "Arrested in Corona while walking home with his wife and four children, who are U.S. citizens.",
    bolded_part: "who are U.S. citizens",
  },
  {
    section: "Intro",
    name: "Leonardo",
    age: "",
    origin_country: "Mexico",
    arrest_date: "1/11/2026",
    description: "Arrested while walking to church in Brooklyn.",
    bolded_part: "walking to church",
  },
  {
    section: "Intro",
    name: "Edgar",
    age: "",
    origin_country: "Guatemala",
    arrest_date: "1/16/2026",
    description:
      "Arrested on his way to work at a roofing company in Sunset Park.",
    bolded_part: "his way to work",
  },
  {
    section: "Intro",
    name: "Hector",
    age: "",
    origin_country: "the Dominican Republic",
    arrest_date: "1/23/2026",
    description: "Arrested while working as a Doordash driver.",
    bolded_part: "Doordash driver",
  },
  {
    section: "Intro",
    name: "Christian",
    age: "",
    origin_country: "Ecuador",
    arrest_date: "12/15/2025",
    description:
      "Arrested while sitting in a car outside a house he was renovating in The Bronx.",
    bolded_part: "sitting in a car",
  },
  {
    section: "Section 1 Subhed",
    name: "Florencio",
    age: "",
    origin_country: "Guatemala",
    arrest_date: "11/5/2025",
    description:
      "Stopped on his way home from work. ICE agents said he had “the same build and likeness” to the person they were trying to arrest.",
    bolded_part: "build and likeness",
  },
  {
    section: "Section 2 Subhed",
    name: "Diego",
    age: "",
    origin_country: "Ecuador",
    arrest_date: "2/16/2026",
    description:
      "Agents tried to pry him from his car, leaving his face bloody. He had to be hospitalized.",
    bolded_part: "be hospitalized",
  },
  {
    section: "Section 3 Subhed",
    name: "Jose",
    age: "",
    origin_country: "Guatemala",
    arrest_date: "11/04/2025",
    description:
      "Arrested on his way to work in Corona, Queens. ICE agents took him first to 26 Federal Plaza and then to Delaney Hall, a detention center in Newark.",
    bolded_part: "Delaney Hall",
  },
  {
    section: "Section 4 Subhed",
    name: "Alejandro",
    age: "",
    origin_country: "Mexico",
    arrest_date: "2/24/2026",
    description:
      "Arrested outside his house in Bushwick. Volunteers rushed to the scene and helped him file a petition. He was released in just over a week.",
    bolded_part: "in just over a week",
  },
];
